define('lq/runtimeLocation',[], function () {
    'use strict';

    // When the application hides the url, the address bar stays on the tenant root and the url the
    // runtime is really on is kept in history.state.actualUrl. Anything that needs the current url (return
    // urls for logins, query string parameters) must read it from here instead of window.location.
    var tracking = false;

    var getUrl = function () {
        var state = window.history.state;
        var href = tracking && state && state.actualUrl ? state.actualUrl : window.location.href;
        return new URL(href, window.location.href);
    };

    return {
        // called by the SPA runtime once it starts recording the real url in history.state.actualUrl
        // (until then history.state may still hold a url from before a reload)
        startTracking: function () {
            tracking = true;
        },

        getPathAndSearch: function () {
            var url = getUrl();
            return url.pathname + url.search;
        },

        getSearch: function () {
            return getUrl().search;
        }
    };
});

